export default {
  SET_SIDEBAR_OPEN(state, payload) {
    state.sidebarOpen = payload
  },
}
